const ACADEMY_PREFIX = "/academy";

export const AcademyNavigatorApiEndpoints = {
  FETCH_MY_PLAYERS: `${ACADEMY_PREFIX}/organization-player`,
  GET_ORGANIZATION: `${ACADEMY_PREFIX}/organization`,
  GET_FAVOURITE_STORAGE_ITEMS: `${ACADEMY_PREFIX}/storage/favorite`,
  GET_RECENT_STORAGE_ITEMS: `${ACADEMY_PREFIX}/storage/recent`,
  FETCH_STORAGE_ORGANIZATION_ITEMS: `${ACADEMY_PREFIX}/storage/organization`,
  ADD_STORAGE_ORGANIZATION_ITEM: `${ACADEMY_PREFIX}/storage/organization`,
  UPLOAD_STORAGE_ORGANIZATION_FILE: `${ACADEMY_PREFIX}/file/presigned-url/organization`,
  UPDATE_STORAGE_ITEM_NAME: `${ACADEMY_PREFIX}/storage/organization`,
  CREATE_ASSIGNMENT: `${ACADEMY_PREFIX}/assignment`,
  GET_ASSIGNMENT: `${ACADEMY_PREFIX}/assignment`,
  UPDATE_FORM_TASK: `${ACADEMY_PREFIX}/task/form`,
  GET_FORM_TASK: `${ACADEMY_PREFIX}/task/form`,
  UPDATE_TODO_TASK: `${ACADEMY_PREFIX}/task/todo`,
  GET_TODO_TASK: `${ACADEMY_PREFIX}/task/todo`,
  ADD_RECENT_STORAGE_ITEM: `${ACADEMY_PREFIX}/storage/recent/organization`,
  FETCH_LEVELS: "/org-admin/level/organization",
  FIND_CURRENT_USER: "/users/profile",
  FETCH_AWS_LINKS_FOR_UPLOAD_FILES: `${ACADEMY_PREFIX}/file/presigned-url`
};
